export default __webpack_public_path__ + "static/media/No2.abdef91b.jpg";